import { styled } from "@pigment-css/react";
import { pressInteraction } from "@acto/taskpane/field-sales-2/styles/pressInteraction";

/**
 * Styled primitives for the recap edit-todo screen's two section sub-components
 * (TodoDescriptionField, TodoDueDateField). Scoped to RecapEditing/ since both consumers live here.
 */

/**
 * Glass card hosting one expandable section on the recap edit-todo screen (description, due-date).
 * `overflow: hidden` clips the Collapse to the rounding.
 */
export const EditFieldCard = styled("div")(({ theme }) => ({
  overflow: "hidden",
  borderRadius: theme.fieldSalesTwo.radius[38],
  background: theme.fieldSalesTwo.colors.surface.glass,
  border: `1px solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
}));

/**
 * Inner padding for an expanded edit-field section (inside EditFieldCard).
 */
export const EditFieldPad = styled("div")(({ theme }) => ({
  padding: `${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[20]}`,
}));

/**
 * A collapsed summary/trigger row used for both the closed description and the closed due-date on
 * the recap edit-todo screen — the whole row is the tap target.
 */
export const EditFieldRow = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.fieldSalesTwo.spacing[16],
  width: "100%",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  padding: `${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[20]}`,
  ...pressInteraction(theme, { scale: 1 }),
  // Disabled means "not clickable" — the chevron is dropped at the call site, but the label stays
  // full-contrast rather than greying out.
  "&:disabled": { pointerEvents: "none", cursor: "default" },
}));

export const EditFieldRowLeft = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[8],
  flexShrink: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[16],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  color: theme.fieldSalesTwo.colors.neutral[700],
  "& svg": { width: theme.fieldSalesTwo.spacing[20], height: theme.fieldSalesTwo.spacing[20] },
}));

export const EditFieldRowValue = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[8],
  minWidth: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[16],
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  color: theme.fieldSalesTwo.colors.neutral[900],
  "& svg": { flexShrink: 0, width: theme.fieldSalesTwo.spacing[18], height: theme.fieldSalesTwo.spacing[18] },
}));
